import RereservationCompletePage from "@/public/components/features/rereservation_complete/RereservationCompletePage"

const RereservationComplete = () => {
	return <RereservationCompletePage />
}

export default RereservationComplete
